import { render } from "./Shipping.vue?vue&type=template&id=80a07284&scoped=true"
import script from "./Shipping.vue?vue&type=script&lang=js"
export * from "./Shipping.vue?vue&type=script&lang=js"

import "./Shipping.vue?vue&type=style&index=0&id=80a07284&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80a07284"]])

export default __exports__